import { render, staticRenderFns } from "./landlord_spd_but_has_lodgers.vue?vue&type=template&id=2d3ab50e"
import script from "./landlord_spd_but_has_lodgers.vue?vue&type=script&lang=js"
export * from "./landlord_spd_but_has_lodgers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports